import TradeRuleService from '../../../services/tradeRules.service';
import ProviderService from '../../../services/providers.service';
import axios from 'axios'

var CancelToken = axios.CancelToken;
var Source = null;

export async function getTradeRules(store, { currentPage, pageSize, filters }) {
    try {
        const state = store.state;
        let newFilters = filters || state.TradeRuleList.filters;
        pageSize = (!pageSize || pageSize <= 0) ? 1 : pageSize;
        store.setState({
            TradeRuleList:
            {
                ...state.TradeRuleList,
                filters: newFilters,
                pagination: { ...state.TradeRuleList.pagination, pageSize },
                selectedTradeRules: [],
                isLoading: true
            }
        });

        if (Source) {
            Source.cancel();
        }
        Source = CancelToken.source();
        const { items, pagination } = await TradeRuleService().getTradeRules(currentPage, pageSize, newFilters, Source.token);
        Source = null;
        store.setState({
            TradeRuleList: {
                ...store.state.TradeRuleList,
                items,
                pagination,
                filters: newFilters,
                isLoading: false
            },
            selectedTradeRules: [],
        });
    }
    catch (error) {
        if (axios.isCancel(error)) {
            console.log('request cancelled');
        }
        else {
            throw error;
        }
    }
}

export function setSelectPage(store, newSelectedValue) {
    const tradeRulesToOperate = [...store.state.TradeRuleList.items.map(tradeRule => tradeRule.id)];
    let newSelectedTradeRules = store.state.TradeRuleList.selectedTradeRules;
    tradeRulesToOperate.forEach(element => newSelectedTradeRules = getNewSelectedArray(newSelectedTradeRules, element, newSelectedValue));
    store.setState({ TradeRuleList: { ...store.state.TradeRuleList, selectedTradeRules: newSelectedTradeRules } })
}

export function setSelect(store, { tradeRuleId, newSelectedValue }) {
    const newSelectedTradeRules = getNewSelectedArray(store.state.TradeRuleList.selectedTradeRules, tradeRuleId, newSelectedValue);
    store.setState({ TradeRuleList: { ...store.state.TradeRuleList, selectedTradeRules: newSelectedTradeRules } })
}

export function setSelectAll(store, allSelected) {
    store.setState({ TradeRuleList: { ...store.state.TradeRuleList, allSelected } });
}

function getNewSelectedArray(initialArray, id, newSelectedValue) {
    return newSelectedValue ?
        (initialArray.indexOf(id) !== -1 ? initialArray : [...initialArray, id]) :
        (initialArray.filter(currentId => currentId !== id))
}


export async function disableTradeRule(store, ruleId) {
    const result = await TradeRuleService().disableTradeRule(ruleId);
    if (result) {
        alert("Rule deleted successfullly");
        await refreshTradeRuleList(store);
    }
}

export async function refreshTradeRuleList(store) {
    const state = store.state;
    const filters = state.TradeRuleList.filters;
    const pageSize = state.TradeRuleList.pagination.pageSize;
    const currentPage = state.TradeRuleList.pagination.currentPage;
    getTradeRules(store, { currentPage, pageSize, filters });
}

export async function getProviders(store) {
    const providers = await ProviderService().getAllProviders();
    store.setState({ TradeRuleList: { ...store.state.TradeRuleList, providers } })
}